import React, { useState } from 'react';
import { alpha, Chip, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { Done, Edit } from '@mui/icons-material';
import { TagType } from '../../../../config/tag';

const WorkspaceTagMenu = ({ tags = [], selectedTags = [], onTagChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const labels = tags.filter((tag) => tag.tagType === TagType.LABEL);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
        <Edit fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {labels.map((tag) => {
          const checked = selectedTags?.some((link) => link.tagId === tag.id);

          return (
            <MenuItem key={tag.id} onClick={() => onTagChange(tag.id)}>
              <ListItemIcon>{checked && <Done fontSize="small" />}</ListItemIcon>

              <ListItemText>
                <Chip
                  label={tag.name}
                  sx={{
                    bgcolor: alpha(tag.color, 0.2),
                    color: tag.color,
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    '&:hover': {
                      bgcolor: alpha(tag.color, 0.3),
                    },
                  }}
                />
              </ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default WorkspaceTagMenu;
